import { Button, Dialog, Inline, breakpoints } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import type { ReactNode } from 'react';

interface ModalDialogProps {
  children: ReactNode;
  handleClose: () => void;
  id?: string;
  isOpen: boolean;
  title: string;
}

export const ModalDialog = ({
  children,
  handleClose,
  id = '',
  isOpen,
  title,
}: ModalDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      footer={
        <Inline align="end" collapseBelow={breakpoints._560} spacing={8}>
          <Button onClick={handleClose} variant="primary">
            {t('Close')}
          </Button>
        </Inline>
      }
      id={id}
      isOpen={isOpen}
      onDismiss={handleClose}
      title={title}
    >
      {children}
    </Dialog>
  );
};
